import Icons from './customMarkerIcons';

const gps = 'gps/';
const pl = 'padlocks/';
const earthquakes = 'earthquakes/';

export default {
  [`${gps}track`]: {
    markerLabel: 'Track',
    labelClass: 'custom-track-label',
  },
  [`${pl}batteryLow`]: {
    markerLabel: 'Battery level: Low',
    markerData: Icons.yellow,
  },
  [`${pl}batteryCritical`]: {
    markerLabel: 'Battery level: Critical',
    markerData: Icons.red,
  },
  [`${pl}unlockedLock`]: {
    markerLabel: 'Unlocked',
    labelClass: '',
    markerData: Icons.padUnlocked,
    disable: true,
  },
  [`${pl}lockedLock`]: {
    markerLabel: 'Locked',
    labelClass: '',
    markerData: Icons.padLocked,
    disable: true,
  },
  [`${pl}quickClickAssigned`]: {
    markerLabel: 'Quick Click Assigned',
  },
  [`${pl}quickClickDeleted`]: {
    markerLabel: 'Quick Click Deleted',
  },
  [`${earthquakes}earthquake`]: {
    markerLabel: 'Earthquake',
  },
};
